"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddIdentityDocumentCommand = void 0;
const validator_1 = require("@leavy/validator");
const StepCommand_1 = require("../../common/command/StepCommand");
const UserIdentityModel_1 = require("../model/UserIdentityModel");
const cq_core_1 = require("@leavy/cq-core");
const base_1 = require("../../base");
let AddIdentityDocumentCommand = class AddIdentityDocumentCommand extends StepCommand_1.StepCommand {
};
__decorate([
    (0, validator_1.Type)(() => UserIdentityModel_1.IdentityProofDocumentModel),
    (0, validator_1.IsDefined)(),
    (0, validator_1.ValidateNested)(),
    __metadata("design:type", UserIdentityModel_1.IdentityProofDocumentModel)
], AddIdentityDocumentCommand.prototype, "document", void 0);
AddIdentityDocumentCommand = __decorate([
    (0, cq_core_1.RpcInvocable)({
        namespace: base_1.ONBOARDING_SERVICE_NAME,
        alias: "add_identity_document",
    })
], AddIdentityDocumentCommand);
exports.AddIdentityDocumentCommand = AddIdentityDocumentCommand;
//# sourceMappingURL=AddIdentityDocumentCommand.js.map